import type { FC } from 'react';
import { Search } from 'lucide-react';

import { Input, type InputProps } from './Input.js';
import { cn } from './cn.js';

/** Поле поиска: инпут с иконкой слева. Дебаунс - забота вызывающего (useDebouncedValue). */
export const SearchInput: FC<InputProps> = ({ className, ...rest }) => (
  <div className={cn('relative', className)}>
    <Search
      aria-hidden
      className="pointer-events-none absolute top-1/2 left-3 size-4 -translate-y-1/2 text-ink-400"
    />
    <Input type="search" className="pl-9" {...rest} />
  </div>
);
